export default "__VITE_ASSET__oabAYv_5__"